import i18n from "@/libs/i18n";
export default [
  {
    get header() {
      return i18n.t("reception.reception");
    },
    role: "reception",
  },
  {
    get title() {
      return i18n.t("common.main-dashboard");
    },
    route: "main-dashboard",
    icon: "HomeIcon",
    role: "reception",
    permission: "get-patient",
  },

  {
    get title() {
      return i18n.t("reception.lobby");
    },
    route: "Reception-Lobby",
    icon: "ListIcon",
    role: "reception",
    permission: "get-patientCard",
  },
  {
    get title() {
      return i18n.t("reception.reception-dashboard");
    },
    route: "Reception-Departments",
    icon: "UsersIcon",
    permission: "get-patient",
    role: "reception",
  },
  // {
  //   get title() {
  //     return i18n.t('reception.search-patient');
  //   },
  //   route: 'Reception-Search',
  //   icon: 'SearchIcon',
  //   permission: 'get-patient',
  //   role: 'Reception',
  // },

  // {
  //   get title() {
  //     return i18n.t('reception.search-advance');
  //   },
  //   route: 'Reception-Advance-Search',
  //   icon: 'SearchIcon',

  //   role: 'Reception',
  // },
  {
    get title() {
      return i18n.t("reception.register-patient");
    },
    route: "register-patient",
    icon: "UserPlusIcon",
    permission: "store-patient",
    role: "reception",
  },
  {
    get title() {
      return i18n.t("reception.patient-surgery");
    },
    route: "add-patient-to-sergery",
    icon: "UserPlusIcon",
    permission: "store-patient",
    role: "reception",
  },
  {
    get title() {
      return i18n.t("quickInvoice.title");
    },
    route: "quick-invoice",
    icon: "BriefcaseIcon",
    permission: "store-patient",
    role: "reception",
  },
];
